import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider, useLang } from "@/context/LanguageContext";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { ValuesMarquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { Portfolio } from "@/components/site/Portfolio";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { FloatingButtons } from "@/components/site/FloatingButtons";

const SEO = {
  ru: {
    title: "Мастер на все руки — Ремонт, строительство и недвижимость",
    desc: "Профессиональный ремонт, реновация, строительство, сантехника, электрика и услуги недвижимости для дома, офиса и бизнеса.",
  },
  en: {
    title: "Мастер на все руки — Repair, Construction & Real Estate",
    desc: "Professional repair, renovation, construction, plumbing, electrical and real estate services for home, office and business.",
  },
  tr: {
    title: "Мастер на все руки — Tamir, İnşaat ve Emlak",
    desc: "Ev, ofis ve işletme için profesyonel tamir, tadilat, inşaat, tesisat, elektrik ve emlak hizmetleri.",
  },
};

function Site() {
  const { lang } = useLang();

  useEffect(() => {
    document.documentElement.lang = lang;
    const s = SEO[lang] || SEO.ru;
    document.title = s.title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = s.desc;
  }, [lang]);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <ValuesMarquee />
        <About />
        <Services />
        <WhyChooseUs />
        <Portfolio />
        <HowItWorks />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <Site />
    </LanguageProvider>
  );
}

export default App;
